import React, {useMemo,useState,useEffect} from 'react';
import {RouteComponentProps, Link} from 'react-router-dom'//yarn add @types/react-router-dom
import useReactRouter from 'use-react-router';
import useStyles from './Styles';
//import Hidden from '@mui/material/Hidden';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import FormControl from '@mui/material/FormControl';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import {Info} from './Inc';
import Ajax from './Ajax';
import NavButton from './NavButton';
import Title from './Title';
import Loading from './Loading';

interface RCProps extends RouteComponentProps<{year:string}> {
	
}

// interface InfoListProps {
// 	year?: number,
// }

//let year:number = 0;

const InfoList = ()=> {
    const classes = useStyles();
    const dt = new Date();
    const nowYear = dt.getFullYear();
    const rcp:RCProps = useReactRouter();

    const [values,setValues] = useState({
		year: nowYear,
        isLoading: true,
        infos: [],
    });

    const load = (year:number)=>{
        Ajax.send("info/list",{year:year},(res:any)=>{
            //console.log(res);
            if( res.ok ){
                setValues({...values,isLoading:false,infos:res.infos,year:year});
            } else {
                setValues({...values,isLoading:false,infos:[],year:year});
            }
        });
    }

    const rows = useMemo(()=>{
        if( !values.infos || values.infos.length===0 ){
            return (null);
        }
        return values.infos.map((info:Info,index:number)=>{
            const key = "row"+index;
            const to = "/info/"+info.info_id;
            return (
				<ListItem key={key} button style={{marginBottom:'1em',padding:'0'}} component={Link} to={to}>
					<div>
                        <div className={classes.infoPrimary}>
                            {info.title}
                        </div>
                        <div className={classes.infoSecondary}>
                            {info.publish_time}
                            {info.new_flag && <span className={classes.new} style={{marginLeft:'0.5em'}}>NEW!</span>}
                        </div>
                    </div>
				</ListItem>
            );
        });
    },[values.infos]);

    const jump = (e: React.MouseEvent<HTMLElement>) => {
        if( e.currentTarget.dataset.id ){
            rcp.history.push("/info/year/"+e.currentTarget.dataset.id);
            const year = parseInt(e.currentTarget.dataset.id);
            load(year);
        }
    }
    
    const putYears = useMemo(()=>{
        let years:number[] = [];
        for( let y=nowYear ; y>=2008 ; y-- ){
            years.push( y );
        }
        return years.map((y:number,index:number)=>{
            const key = "year"+index;
            let current = false;
            if( y===values.year ){
                current = true;
            }
            return (
                <NavButton key={key} id={String(y)} onClick={jump} label={String(y)+"年"} disabled={current}/>
            )
        })
    },[nowYear,values.year]);

    useEffect( ()=>{
        window.scrollTo(0,0);
		let year = nowYear;
        if( rcp.match.params.year ){
            year = parseInt(rcp.match.params.year);
        }
        load(year);
    },[]);

    const title = "作家さんへのお知らせ（"+values.year+"年）";

	return (
		<div className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={9}>
                    <Paper className={classes.paper}>
                        <Title text={title} size={1} icon="store"/>
                        <List style={{margin:'0',padding:'0'}}>
                            {rows}
                        </List>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={3}>
                    <Paper className={classes.paper}>
                        <Title text="年を指定" size={2}/>
                        <FormControl fullWidth={true}>
                        {putYears}
                        </FormControl>
                    </Paper>
                </Grid>
            </Grid>
			<Loading isLoading={values.isLoading}/>
		</div>
	);
}

export default InfoList;
